enum EnumLegalPartnerType {
	CompanyIncomingPayments = 0,
	CompanyOutgoingPayments = 1
}
export default EnumLegalPartnerType
